import permissions from './permission-list'

export default [
  {
    path: '/transactions',
    name: 'transactions',
    component: () => import('@/views/transactions/index.vue'),
    meta: {
      pageTitle: 'Daftar Transaksi',
      resource: permissions.transaction,
      action: 'read',
      navActiveLink: 'transactions',
      localstorage: {
        query: 'transactions-query',
      },
      breadcrumb: [
        {
          text: 'Transaksi',
          active: true,
        },
      ],
    },
  },
  {
    path: '/transactions/:id/detail',
    name: 'transactions-detail',
    component: () => import('@/views/transactions/detail.vue'),
    meta: {
      pageTitle: 'Detail Transaksi',
      resource: permissions.transaction,
      action: 'read',
      navActiveLink: 'transactions',
      breadcrumb: [
        {
          text: 'Transaksi',
          active: false,
          to: { path: '/transactions' },
        },
        {
          text: 'Detail',
        },
      ],
    },
  },
  {
    path: '/transactions/:id/packing-label',
    name: 'transactions-packing-label',
    component: () => import('@/views/transactions/packing.vue'),
    meta: {
      pageTitle: 'Label Kemasan',
      resource: permissions.transaction,
      action: 'read',
      navActiveLink: 'transactions',
      breadcrumb: [
        {
          text: 'Transaksi',
          active: false,
          to: { path: '/transactions' },
        },
        {
          text: 'Label Kemasan',
        },
      ],
    },
  },
  {
    path: '/transactions/:id/invoice',
    name: 'transactions-packing-label',
    component: () => import('@/views/transactions/Invoice.vue'),
    meta: {
      pageTitle: 'Invoice',
      resource: permissions.transaction,
      action: 'read',
      navActiveLink: 'transactions',
      layout: 'full',
      breadcrumb: [
        {
          text: 'Transaksi',
          active: false,
          to: { path: '/transactions' },
        },
        {
          text: 'Invoice',
        },
      ],
    },
  },
]
